import { ReactComponent as IconArrowRight } from 'assets/icons/icon-arrow-right.svg';
import styled from 'styled-components';
import { theme } from 'styles/theme';

interface PrivacyLinkProps extends React.HTMLProps<HTMLDivElement> {}

const PrivacyLink: React.FC<PrivacyLinkProps> = (props) => {
  return (
    <PrivacyWrapper {...props}>
      <Privacy href="https://www.remondisrecycling.se/dataskyddspolicy/" target="_blank">
        Så hanterar vi dina personuppgifter
      </Privacy>
      <IconArrowRight />
    </PrivacyWrapper>
  );
};

export default PrivacyLink;

const Privacy = styled.a`
  color: ${theme.colors.secondary_text};
  font-weight: 400;
  text-decoration: none;
  transition: color 0.3s ease;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 1px;
    background-color: ${theme.colors.secondary_text};
    transition:
      width 0.3s ease,
      background-color 0.3s ease;
  }

  &:hover {
    color: ${theme.colors.primary};
  }

  @media (hover: hover) {
    &:hover::after {
      width: 100%;
      background-color: ${theme.colors.primary};
    }
  }
`;

const PrivacyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  ${Privacy}:hover + svg path {
    stroke: ${theme.colors.primary};
  }

  svg {
    display: inline-block;
    vertical-align: middle;
    margin-left: 4px;

    path {
      stroke: ${theme.colors.grayscale};
      transition: stroke 0.3s ease;
    }
  }
`;
